// import { action } from 'easy-peasy';

const sharedModel = {};

export default sharedModel;
